<h1>Sync Templates to Outcomes</h1>
<hr />
<form #formValue="ngForm" (ngSubmit)="syncTemplateToOutcomes(formValue)">
  <div class="row">
    <div class="col-6">
      <div>Template Type <span class="mandatory">*</span></div>
      <p-dropdown
        [(ngModel)]="selectedTemplate"
        [options]="templateFilter"
        placeholder="All Template"
        optionLabel="label"
        optionValue="value"
        name="selectedTemplate"
        (onChange)="changeTemplate($event)"
        required
      >
        <ng-template let-option pTemplate="item">
          <div class="p-multiselect-representative-option">
            <span class="ml-1">{{ option.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <div *ngIf="formValue.submitted && !selectedTemplate" class="text-danger">
        Template Type is required.
      </div>
    </div>
    <div
      class="col-6"
      *ngIf="['teamparent', 'team'].includes(selectedTemplate)"
    >
      <div>Group <span class="mandatory">*</span></div>
      <p-dropdown #groupDropdown
        [(ngModel)]="selectedGroup"
        (onFilter)="onSyncGroupSearch($event)"
        [options]="selectedTemplate == 'team' ? groupFilter : parentgroupFilter"
        (onChange)="helper.clearDropdownFilter(groupDropdown)"
        filter="true"
        placeholder="Select Group"
        optionLabel="name"
        optionValue="group_id"
        name="group_id"
        required
      >
        <ng-template let-option pTemplate="item">
          <div class="p-multiselect-representative-option">
            <span class="ml-1">{{ option.name }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <div *ngIf="formValue.submitted && !selectedGroup" class="text-danger">
        Group Type is required.
      </div>
    </div>

    <div class="col-6" *ngIf="selectedTemplate === 'individual'">
      <div>User <span class="mandatory">*</span></div>
      <p-dropdown
        #userDropdown
        [(ngModel)]="selectedUser"
        [options]="users"
        (onFilter)="onSyncUserSearch($event)"
        filter="true"
        placeholder="Select User"
        optionLabel="name"
        optionValue="user_id"
        name="user_id"
        (onChange)="helper.clearDropdownFilter(userDropdown)"
        required
      >
        <ng-template let-option pTemplate="item">
          <div class="p-multiselect-representative-option">
            <span class="ml-1">{{ option.name }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <div *ngIf="formValue.submitted && !selectedUser" class="text-danger">
        User is required.
      </div>
    </div>
  </div>
  <br />
  <br />
  <button
    type="submit"
    class="btn primary"
    style="border: 0; text-align: center"
  >
    Template Outcomes
  </button>
</form>
